export default __webpack_public_path__ + "static/media/c1.879ef8db.svg";